import { QueryLazyOptions } from "@apollo/client";
import { useUser } from "@saleor/auth";
import Autocomplete from "@saleor/components/AutocompleteForObject";
import {
  DistributionChannelType,
  Exact
  // ExportShipToFilterInput,
  // ExportSoldToFilterInput,
  // FilterShipToExportOrderQuery,
  // FilterSoldToExportOrderQuery,
  // FilterSoldToScgCheckoutQuery
} from "@saleor/graphql";
import useLocalPaginator, {
  useLocalPaginationState
} from "@saleor/hooks/useLocalPaginator";
import uniqBy from "lodash/uniqBy";
import React, { useEffect, useRef, useState } from "react";
interface IProps {
  handleSelectedSearch?: (value: any) => void;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  first?: number;
  isClean?: boolean;
  contained: boolean;
  name?: string;
  totalCount?: number;
  getDataSuggestions: (
    options?: QueryLazyOptions<
      Exact<{
        distributionChannelType?: DistributionChannelType;
        filter?: any;
        first?: number;
        bu?: string;
        saleOrg?: string;
      }>
    >
  ) => void;
  fetchDataSuggestions?: any;
  loadingDataSuggestion: boolean;
  dataOptions: any[];
  error?: boolean;
  searchField: string;
  objectSuggestion?: boolean;
  defaultInputValue?: string;
  defaultValue?: any;
  withNonSelect?: boolean;
  inputValue?: boolean;
  disabled?: boolean;
  pageInfo?: any;
  showLoadMore?: boolean;
  disableDuplicationLoading?: boolean;
  isCheckingRole?: boolean;
  isSearchIcon?: boolean;
  id?: string;
  testId?: string;
  saleOrganization?: string;
  resetInputValueOnBlur?: boolean;
  onMouseLeave?(event: any);

  onClear?(event?: any);
}

interface LastItemParamsProps {
  id: string;
  position: number;
}

const InputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    handleSelectedSearch,
    placeholder,
    first,
    isClean,
    contained,
    totalCount,
    getDataSuggestions,
    loadingDataSuggestion,
    dataOptions,
    error,
    searchField,
    objectSuggestion,
    onMouseLeave,
    defaultInputValue,
    defaultValue,
    withNonSelect,
    disabled,
    pageInfo,
    showLoadMore,
    disableDuplicationLoading,
    isCheckingRole,
    isSearchIcon,
    id,
    testId,
    name,
    saleOrganization = "",
    resetInputValueOnBlur = false
  } = props;

  const firstRender = useRef(true);
  const [value, setValue] = useState<string>("");
  const [opts, setOpts] = useState<any[]>([]);
  const [lazyLoadOptions, setLazyLoadOptions] = useState<boolean>(false);
  const [
    valuesPaginationState,
    setValuesPaginationState
  ] = useLocalPaginationState(100);
  const paginateValues = useLocalPaginator(setValuesPaginationState);
  const { loadNextPage } = paginateValues(pageInfo, valuesPaginationState);
  const [lastItemParams, setLastItemParams] = useState<LastItemParamsProps>(
    null
  );

  const { zone } = useUser();

  useEffect(() => {
    if (firstRender.current && !value && defaultInputValue && defaultValue) {
      setValue(defaultInputValue);
      firstRender.current = false;
    }
  }, [defaultInputValue, defaultValue, firstRender.current]);

  const handleChange = event => {
    setValue(event);
  };

  const onLastItemVisible = (id: string, position: number) => {
    setLastItemParams({ id, position });
    setLazyLoadOptions(true);
    loadNextPage();
  };

  useEffect(() => {
    if (value?.length >= 2) {
      const filterObj = { [searchField]: value };
      getDataSuggestions({
        variables: {
          first: first || 100,
          filter: filterObj,
          distributionChannelType: isCheckingRole
            ? (zone?.toUpperCase() as DistributionChannelType)
            : undefined,
          ...valuesPaginationState,
          bu: "PP",
          ...(saleOrganization !== "" && { saleOrg: saleOrganization })
        }
      });
    }
  }, [value, valuesPaginationState, saleOrganization]);

  useEffect(() => {
    let newDataOptions = [...dataOptions];
    if (lazyLoadOptions) {
      newDataOptions.push(...opts);
    }
    // check the item that already remove duplicate from BE or not
    if (!disableDuplicationLoading) {
      newDataOptions = uniqBy(newDataOptions, "value");
    }
    setOpts(newDataOptions);

    if (lastItemParams?.id) {
      setTimeout(() => {
        const { id: lastItemId, position } = lastItemParams;
        const el = document.getElementById(lastItemId);
        if (el) {
          el.scrollTo({ top: position });
        }
      }, 100);
    }
    setLazyLoadOptions(false);
  }, [dataOptions]);

  useEffect(() => {
    setLastItemParams(null);
  }, [value]);

  return (
    <div>
      <Autocomplete
        contained={contained}
        defaultInputValue={defaultInputValue}
        optionsProp={opts}
        placeholderProps={placeholder}
        totalCount={totalCount || opts.length}
        onLastItemVisible={showLoadMore && onLastItemVisible}
        onChangeProps={e => {
          handleChange(e);
          if (withNonSelect) {
            handleSelectedSearch(e);
          }
        }}
        loading={loadingDataSuggestion}
        onSearch={handleSelectedSearch}
        objectSuggestion={objectSuggestion}
        isReset={isClean}
        defaultValue={defaultValue}
        onMouseLeave={onMouseLeave}
        error={error}
        disabled={disabled}
        isSearchIcon={isSearchIcon}
        notUseFilterOptions
        id={id}
        testId={testId}
        name={name}
        resetInputValueOnBlur={resetInputValueOnBlur}
      />
    </div>
  );
};

export default InputSuggestion;
